import React from 'react';
import { Stack, Avatar, Box, ListItem, Typography, Divider } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FormDialog from 'pages/sample/FormDialog/FormDialog';
import { onGetAnnouncement } from 'redux/actions/Portal';
import { } from '@mui/material';
import { ButtonContained } from 'shared/components/Button';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import PropTypes from 'prop-types';
import { stringAvatar, Fonts, COLORS } from 'shared/constants/AppEnums';
import InfiniteScroll from 'react-infinite-scroll-component';
import AppList from '../AppList';
import AppScrollbar from '../AppScrollbar';
import { grey } from '@mui/material/colors';
import { Loop } from '@mui/icons-material';

const Pengumuman = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        // dispatch(onGetWidgetsData());
        dispatch(onGetAnnouncement());
    }, [dispatch]);

    const [announcement] = useSelector(
        ({ portal }) => [
            // dashboard.widgetsData,
            portal.announcement
        ]
    );

    const [localAnnouncement, setLocalAnnouncement] = useState(announcement);

    useEffect(() => {
        setLocalAnnouncement(announcement);
    }, [announcement]);

    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    }

    useEffect(() => {
        setLocalAnnouncement(announcement);
    }, [announcement])

    const handleNext = () => {
        let p = localAnnouncement.next.split("=")[1];
        dispatch(onGetAnnouncement(p, true));
    };

    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: {
                        xs: 400,
                        md: 450
                    },
                    gap: 4
                }}
            >

                <Stack flex={1} overflow={'hidden'}>
                    {
                        localAnnouncement.results?.length === 0 ? (
                            <Stack alignItems={'center'} justifyContent={'center'} height={'100% !important'}>
                                <Typography>Tidak ada pengumuman</Typography>
                            </Stack>
                        ) : (
                            <Stack height={1} overflow={'auto'} id="scrollableDiv">
                                <InfiniteScroll
                                    dataLength={localAnnouncement?.results.length || 0}
                                    hasMore={Boolean(localAnnouncement.next)}
                                    next={handleNext}
                                    scrollableTarget="scrollableDiv"
                                    loader={
                                        <Stack direction={'row'} alignItems={'center'} justifyContent={'center'} color={grey[500]} p={2} spacing={1}>
                                            <Box sx={{ animation: 'rotate360 2s linear infinite' }}>
                                                <Loop />
                                            </Box>

                                            <Typography>Loading</Typography>
                                        </Stack>
                                    }
                                >
                                    <AppList
                                        data={localAnnouncement?.results || []}
                                        renderRow={(item, i) => (
                                            <PengumumanItem key={item.id} item={item} />
                                        )}
                                    />
                                </InfiniteScroll>
                            </Stack>
                        )
                    }
                </Stack>

                <Stack px={4}>
                    <ButtonContained onClick={handleClickOpen}>
                        <Typography>Buat Pengumuman</Typography>
                    </ButtonContained>
                </Stack>

                <FormDialog open={open} handleClose={handleClose}></FormDialog>
            </Box>
        </>

    );
};

export default Pengumuman;

const PengumumanItem = (props) => {
    const { item } = props;
    return (
        <ListItem
            className='item-hover'
            alignItems='flex-start'
            sx={{
                px: 4,
                transition: '0.3s ease-in-out',
                '&:hover': {
                    bgcolor: (theme) => theme.palette.grey[200],
                }
            }}
        >
            <ListItemAvatar
                sx={{
                    minWidth: 0,
                    mr: 4,
                    mt: 0
                }}
            >
                {
                    item.creator.avatar ? (
                        <Avatar alt={item.creator.name} src={item.creator.avatar} />
                    ) : (
                        <Avatar {...stringAvatar(item.creator.name)} />
                    )
                }
            </ListItemAvatar>
            <Box
                sx={{
                    fontSize: 14,
                    color: (theme) => theme.palette.text.secondary,
                    overflow: 'hidden',
                    wordBreak: 'break-word',
                    whiteSpace: 'pre-line'
                }}
            >
                <Typography>
                    <Box
                        component='span'
                        sx={{
                            fontSize: 14,
                            fontWeight: Fonts.MEDIUM,
                            mb: 0.5,
                            color: (theme) => theme.palette.text.primary,
                            mr: 1,
                            display: 'inline-block',
                        }}
                    >
                        {item.creator.name}
                    </Box>
                    <Box dangerouslySetInnerHTML={{ __html: item.content }} component='span'>
                    </Box>
                </Typography>
            </Box>
        </ListItem>
    );
};

PengumumanItem.propTypes = {
    item: PropTypes.object.isRequired,
};
